const USER_PROFILE_LOADING = "USER_PROFILE_LOADING";
const USER_PROFILE_SUCCESS = "USER_PROFILE_SUCCESS";
const USER_PROFILE_ERROR = "USER_PROFILE_ERROR";

export {
    USER_PROFILE_LOADING,
    USER_PROFILE_ERROR,
    USER_PROFILE_SUCCESS,
};